import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import FeaturedLogos from './components/FeaturedLogos';
import WhyAlpha from './components/WhyAlpha';
import Services from './components/Services';
import Testimonials from './components/Testimonials';
import ContactForm from './components/ContactForm';
import Location from './components/Location';
import AboutUs from './components/AboutUs';
import Footer from './components/Footer';

function App() {
  return (
    <div className="font-sans text-slate-900 bg-white">
      <Navbar />
      <Hero />
      {/* <FeaturedLogos /> */}
      <WhyAlpha />
      <AboutUs />
      <Services />
      {/* <Testimonials /> */}
      <ContactForm />
      <Location />
      <Footer />
    </div>
  );
}

export default App;
